import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './app-evaluation-overview.module.scss';

type Props = {
  clearName: string;
  onClear: () => void;
  label: string;
};

// Each ✕ names its chip: a row of identically named buttons cannot be told apart.
const FilterChip: FC<Props> = ({ clearName, onClear, label }) => {
  const [t] = useTranslation('evaluations');
  return (
    <span className={styles.filterChip}>
      <span className={styles.filterChipLabel} title={label}>
        {label}
      </span>
      <button
        type="button"
        className={styles.filterChipClose}
        aria-label={t('overview.pill.remove', 'Rensa filter: {{name}}', { name: clearName })}
        onClick={onClear}
      >
        ✕
      </button>
    </span>
  );
};

export default FilterChip;
